import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ mode: "system", resolved: "dark", setMode: () => {} });

function systemMode() {
  return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
}

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => localStorage.getItem("formigen-theme") || "system");
  const [resolved, setResolved] = useState(() => (mode === "system" ? systemMode() : mode));

  useEffect(() => {
    const apply = () => {
      const r = mode === "system" ? systemMode() : mode;
      setResolved(r);
      const el = document.documentElement;
      el.classList.remove("dark", "light");
      if (mode !== "system") el.classList.add(mode);
    };
    apply();
    const mq = window.matchMedia("(prefers-color-scheme: light)");
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, [mode]);

  const setMode = (m) => {
    localStorage.setItem("formigen-theme", m);
    setModeState(m);
  };

  return <ThemeCtx.Provider value={{ mode, resolved, setMode }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
